import { defineMessages } from 'react-intl'

export default defineMessages({
    "couldNotResetPassword": {
        "defaultMessage": "We couldn't reset your password. Please try again.",
        "id": "src.LoginPage.resetPassword.errorMessage.body"
    },
    "email": {
        "defaultMessage": "Email",
        "id": "src.LoginPage.resetPassword.email.placeholder"
    },
    "emailAddress": {
        "defaultMessage": "Email Address",
        "id": "src.LoginPage.emailAddress.placeholder"
    },
    "failedEmailMessage": {
        "defaultMessage": "The reset password email to {email} hasn't been sent. Please try again.",
        "id": "src.LoginPage.resetEmail.errorMessage.body"
    },
    "failedLogin": {
        "defaultMessage": "We could't log you in. Please check your login details and try again.",
        "id": "src.LoginPage.failedLogin.errorMessage.body"
    },
    "incorrectRole": {
        "defaultMessage": "Only business admins can access this content.",
        "id": "src.LoginPage.incorrectRole.notification"
    },
    "incorrectUrlMessage": {
        "defaultMessage": "We couldn't find an account with this email. Please try again.",
        "id": "src.LoginPage.wrongEmail.errorMessage.body"
    },
    "login": {
        "defaultMessage": "Log In",
        "id": "src.LoginPage.login.button"
    },
    "loginHeader": {
        "defaultMessage": "Log in to create a ride",
        "id": "src.LoginPage.loginHeader"
    },
    "newPassword": {
        "defaultMessage": "New Password",
        "id": "src.LoginPage.resetPassword.newPassword.placeholder"
    },
    "password": {
        "defaultMessage": "Password",
        "id": "src.LoginPage.password.placeholder"
    },
    "passwordsDoNotMatch": {
        "defaultMessage": "Passwords don't match. Please check and try again.",
        "id": "src.LoginPage.resetPassword.matchingError.body"
    },
    "passwordTooShort": {
        "defaultMessage": "Password must be at least 8 characters long",
        "id": "src.LoginPage.resetPassword.error.underline"
    },
    "repeatNewPassword": {
        "defaultMessage": "Repeat New Password",
        "id": "src.LoginPage.resetPassword.repeatPassword.placeholder"
    },
    "resetPassword": {
        "defaultMessage": "Reset Password",
        "id": "src.LoginPage.requestResetPassword.header"
    },
    "resetPasswordComplete": {
        "defaultMessage": "Password reset complete! You'll be redirected to the Business Portal.",
        "id": "src.LoginPage.resetPassword.successMessage"
    },
    "resetPasswordFor": {
        "defaultMessage": "Reset Password For",
        "id": "src.LoginPage.resetPassword.header"
    },
    "sendEmail": {
        "defaultMessage": "Send Email",
        "id": "src.LoginPage.resetPassword.sendEmail.button"
    },
    "validEmailMessage": {
        "defaultMessage": "If {email} is registered in our system, then we've just sent you an email with a link to reset your password.",
        "id": "src.LoginPage.resetPassword.emailSent.confirmationMessage"
    }
})

